import { Socials } from '../types/data/socials';

const socials: Socials = [
    {
        name: 'YouTube',
        username: 'Hai Halo Epel',
        url: 'https://youtube.com/c/HaiHaloEpel',
    },
    {
        name: 'Twitter',
        username: 'EpelEvelyn',
        url: 'https://twitter.com/EpelEvelyn',
    },
    {
        name: 'Facebook',
        username: 'haihalo.epel',
        url: 'https://facebook.com/haihalo.epel',
    },
    {
        name: 'Instagram',
        username: 'haihalo.epel',
        url: 'https://instagram.com/HaiHalo.Epel',
    },
    {
        name: 'Smule',
        username: 'EpelEvelyn',
        url: 'https://smule.com/EpelEvelyn',
    },
    {
        name: 'TikTok',
        username: 'HaiHaloEpel',
        url: 'https://tiktok.com/@HaiHaloEpel',
    },
    {
        name: 'Discord',
        username: '💙 Piolet Eplegorden 💙',
        url: 'https://bit.ly/HaiHaloServer',
    },
    {
        name: 'Trakteer',
        username: 'HaiHaloEpel',
        url: 'https://trakteer.id/HaiHaloEpel',
    },
    {
        name: 'Saweria',
        username: 'HaiHaloEpel',
        url: 'https://saweria.co/HaiHaloEpel',
    },
    {
        name: 'Karyakarsa',
        username: 'HaiHaloEpel',
        url: 'https://karyakarsa.com/HaiHaloEpel',
    },
    {
        name: 'Streamlabs',
        username: 'evelynvtuber',
        url: 'https://streamlabs.com/evelynvtuber/tip',
    },
    {
        name: 'Steam',
        username: 'EpelEvelyn',
        url: 'https://steamcommunity.com/id/EpelEvelyn',
    },
    {
        name: 'Reality',
        username: 'Epel || Evelyn',
        url: 'https://reality.app/profile/6e0ccda3',
    },
];

export default socials;
